import { BehaviorSubject } from "rxjs";
import * as i0 from "@angular/core";
export class MenuService {
    constructor() {
        this.isOpen = new BehaviorSubject(false);
        this.isOpen$ = this.isOpen.asObservable();
    }
    toggleMenuState() {
        this.isOpen.next(!this.isOpen.getValue());
    }
}
MenuService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function MenuService_Factory() { return new MenuService(); }, token: MenuService, providedIn: "root" });
